import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Grid, Row, Col } from 'react-bootstrap';
import { Parallax } from 'react-scroll-parallax';
import queryString from 'query-string';

import Layout from '../ui/Layout';
import Loading from '../ui/Loading';
import fetchDux from '../../state/fetch-dux';

const chunk = array =>
  array.reduce(
    (r, v) =>
      (!r.length || r[r.length - 1].length === 2
        ? r.push([v])
        : r[r.length - 1].push(v)) && r,
    []
  );

class HowWeDoIt extends Component {
  constructor(props) {
    super(props);
    this.state = { isPreview: false };
  }
  componentWillMount() {
    window.scrollTo(0, 0);
    const qs = queryString.parse(this.props.location.search) || {};
    this.props.getContent({
      page: 'how-we-do-it',
      preview: qs.preview
    });
    this.setState({ isPreview: !!qs.preview });
  }
  componentWillUnmount() {
    this.props.clearGetContent();
  }
  render() {
    const { result, inProgress } = this.props;
    const { isPreview } = this.state;

    const { data, versionName } = result || {};
    return (
      <Layout
        route="how-we-do-it"
        isPreview={isPreview}
        versionName={versionName}
      >
        {inProgress && <Loading />}
        {!inProgress &&
          data &&
          <main>

            <Parallax
              offsetYMax={10}
              offsetYMin={-10}
              className="grape"
              slowerScrollRate
            />

            <Grid>
              <Row>
                <Col sm={12}>

                  <Parallax offsetYMax={10} offsetYMin={-10}>
                    <section className="box-text">
                      <h2>{data.scienceAndMethodology.tagline}</h2>
                      <h1>{data.scienceAndMethodology.title}</h1>
                      <p>{data.scienceAndMethodology.description}</p>
                    </section>
                  </Parallax>

                  <section className="box-details">
                    <p>{data.scienceAndMethodology.text}</p>
                  </section>

                  <section className="box-why-we-do-it">
                    <div className="line" />
                    <Parallax offsetYMax={10} offsetYMin={-10}>
                      <div className="image">
                        <div
                          style={{
                            backgroundImage: `url(${(data.whyWeDoIt || {}).image.href})`
                          }}
                        />
                      </div>
                    </Parallax>
                    <article>
                      <h3>{data.whyWeDoIt.title}</h3>
                      <p>{data.whyWeDoIt.text}</p>
                    </article>
                  </section>

                  <section className="box-phenolic">
                    <Parallax offsetYMax={10} offsetYMin={-10} slowerScrollRate>
                      <div className="image">
                        <div
                          style={{
                            backgroundImage: `url(${(data.phenolicAssays.image || {}).href})`
                          }}
                        />
                      </div>
                    </Parallax>
                    <Parallax offsetYMax={10} offsetYMin={-10}>
                      <h3>{data.phenolicAssays.title}</h3>
                      <h4>{data.phenolicAssays.tagline}</h4>
                    </Parallax>
                    <p>{data.phenolicAssays.text}</p>
                  </section>

                  <section className="box-measure">
                    <h3>{data.whatWeMeasure.header}</h3>

                    {data.whatWeMeasure.items.length &&
                      <div className="groups">
                        {chunk(data.whatWeMeasure.items).map((group, index) => (
                          <div className="group" key={index}>
                            {group.map((article, index) => {
                              const {
                                title,
                                description,
                                knowledgeCenterLink,
                                knowledgeCenterLinkText
                              } = article || {};

                              const {
                                data
                              } = knowledgeCenterLink || {};

                              return (
                                <Parallax
                                  offsetYMax={10}
                                  offsetYMin={-10}
                                  key={index}
                                  slowerScrollRate={index % 2}
                                >
                                  <article>
                                    <h4>{title}</h4>
                                    <p style={{ whiteSpace: 'pre-wrap' }}>{description}</p>
                                    {knowledgeCenterLink &&
                                      <Link
                                        to={
                                          `/knowledge-center/article/${(data || {}).slug}`
                                        }
                                      >
                                        {knowledgeCenterLinkText}
                                      </Link>}
                                  </article>
                                </Parallax>
                              );
                            })}
                          </div>
                        ))}
                      </div>}

                  </section>

                  <section className="box-how-we-do-it">
                    <div className="headers">
                      <h3>{data.howWeDoIt.title}</h3>
                      <p>{data.howWeDoIt.text}</p>
                    </div>
                    <Parallax offsetYMax={20} offsetYMin={-20}>
                      <div className="tips">
                        <div className="tip one">
                          <div>1</div>
                          <h4>{data.howWeDoIt.step1.header}</h4>
                          <p>{data.howWeDoIt.step1.text}</p>
                        </div>
                        <div className="tip two">
                          <div>2</div>
                          <h4>{data.howWeDoIt.step2.header}</h4>
                          <p>{data.howWeDoIt.step2.text}</p>
                        </div>
                        <div className="tip three">
                          <div>3</div>
                          <h4>{data.howWeDoIt.step3.header}</h4>
                          <p>{data.howWeDoIt.step3.text}</p>
                        </div>
                        <div className="tip four">
                          <div>4</div>
                          <h4>{data.howWeDoIt.step4.header}</h4>
                          <p>{data.howWeDoIt.step4.text}</p>
                        </div>
                        <div className="tip five">
                          <div>5</div>
                          <h4>{data.howWeDoIt.step5.header}</h4>
                          <p>{data.howWeDoIt.step5.text}</p>
                        </div>
                      </div>
                    </Parallax>
                  </section>

                  <section className="box-client-center">
                    <div className="macbook" />
                    <article>
                      <div className="logo" />
                      <p>{data.contact.text}</p>
                      <Link to="/contact-us">
                        {data.contact.contactLinkText}
                      </Link>
                    </article>
                  </section>

                </Col>
              </Row>
            </Grid>

          </main>}
      </Layout>
    );
  }
}

const mapState = state => state.getContent.toJS();

const mapDispatch = dispatch =>
  bindActionCreators(
    {
      getContent: fetchDux.getContent.createAction,
      clearGetContent: fetchDux.getContent.clearAction
    },
    dispatch
  );

export default connect(mapState, mapDispatch)(HowWeDoIt);



// WEBPACK FOOTER //
// ./src/components/routes/HowWeDoIt.js